import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import IndexRepository from '../Repositories/IndexRepository_'

class IndexBloc {

    listChannel = new Subject()
    listDetailChannel = new Subject()
    listPegawaiChannel = new Subject()
    listUnitKerjaChannel = new Subject()
    listJabatanChannel = new Subject()
    inactiveChannel = new Subject()
    inactiveDetailChannel = new Subject()
    detailChannel = new Subject()
    detailMutasiChannel = new Subject()
    regionChannel = new Subject()
    tmtEndChannel = new Subject()
    uploadDecreeChannel = new Subject()
    repository = new IndexRepository()

    constructor() {
        this.listChannel.next({status: apiResponse.INITIAL})
        this.listDetailChannel.next({status: apiResponse.INITIAL})
        this.listPegawaiChannel.next({status: apiResponse.INITIAL})
        this.listUnitKerjaChannel.next({status: apiResponse.INITIAL})
        this.listJabatanChannel.next({status: apiResponse.INITIAL})
        this.inactiveChannel.next({status: apiResponse.INITIAL})
        this.inactiveDetailChannel.next({status: apiResponse.INITIAL})
        this.detailChannel.next({status: apiResponse.INITIAL})
        this.detailMutasiChannel.next({status: apiResponse.INITIAL})
        this.regionChannel.next({status: apiResponse.INITIAL})
        this.tmtEndChannel.next({status: apiResponse.INITIAL})
        this.uploadDecreeChannel.next({status: apiResponse.INITIAL})
    }

    fetchList = async (query) => {
        try {
            this.listChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchList(query).then((result) => {
                this.listChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.listChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }

    fetchListDetail = async (query) => {
        try {
            this.listDetailChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchListDetail(query).then((result) => {
                this.listDetailChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.listDetailChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }

    fetchListPegawai = async (query) => {
        try {
            this.listPegawaiChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchListPegawai(query).then((result) => {
                this.listPegawaiChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.listPegawaiChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }

    fetchListUnitKerja = async (query) => {
        try {
            this.listUnitKerjaChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchListUnitKerja(query).then((result) => {
                this.listUnitKerjaChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.listUnitKerjaChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }


    fetchListJabatan = async (query) => {
        try {
            this.listJabatanChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchListJabatan(query).then((result) => {
                this.listJabatanChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.listJabatanChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }

    fetchInactive = async (query) => {
        try {
            this.inactiveChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchInactive(query).then((result) => {
                this.inactiveChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.inactiveChannel.next({ status: apiResponse.ERROR, data: error })
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchInactiveDetail = async (query) => {
        try {
            this.inactiveDetailChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchInactiveDetail(query).then((result) => {
                this.inactiveDetailChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.inactiveChannel.next({ status: apiResponse.ERROR, data: error })
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchDetail = async (query) => {
        try {
            this.detailChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDetail(query).then((result) => {
                this.detailChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.detailChannel.next({ status: apiResponse.ERROR, data: error })
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchDetailMutasi = async (query) => {
        try {
            this.detailMutasiChannel.next({ status: apiResponse.LOADING })
            await this.repository.fetchDetailMutasi(query).then((result) => {
                this.detailMutasiChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.detailMutasiChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchRegion = async (query) => {
        try {
            this.regionChannel.next({ status: apiResponse.LOADING})
            await this.repository.fetchRegion(query).then((result) => {
                this.regionChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.regionChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Error fetching region')
        }
    }

    fetchTMTEnd = async (query) => {
        try {
            this.tmtEndChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchTMTEnd(query).then((result) => {
                this.tmtEndChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.tmtEndChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }

    ftechUploadDecree = async (query) => {
        try {
            this.uploadDecreeChannel.next({status: apiResponse.LOADING})
            await this.repository.ftechUploadDecree(query).then((result) => {
                this.uploadDecreeChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.uploadDecreeChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }

}

export default IndexBloc